import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import { shouldPolyfill } from '@formatjs/intl-numberformat/should-polyfill';
import App from './App.jsx';

async function polyfill() {
  if (!shouldPolyfill('en')) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import('@formatjs/intl-getcanonicallocales/polyfill');
  await import('@formatjs/intl-locale/polyfill');
  await import('@formatjs/intl-pluralrules/polyfill');
  await import('@formatjs/intl-pluralrules/locale-data/en');
  await import('@formatjs/intl-numberformat/polyfill');
  await import('@formatjs/intl-numberformat/locale-data/en');
}

// eslint-disable-next-line no-undef, no-console
// console.log(calcData);

polyfill();

ReactDOM.render(
  // TODO: create check for calcData
  // eslint-disable-next-line no-undef
  <App calcData={calcData} />,
  document.getElementById('app')
);
